// @story HIR-HR5
// Dates for the offer screens, always in India time — the school's time, not
// whatever the browser happens to be set to.
const TZ = 'Asia/Kolkata';

/* 'YYYY-MM-DD' for a date input, `days` from now. */
export function isoDateInIndia(days = 0) {
  return new Date(Date.now() + days * 86400000).toLocaleDateString('en-CA', { timeZone: TZ });
}

/* "Mon, 12 Oct 2026, 11:59 pm" */
export function formatWhen(d, withTime = true) {
  if (!d) return '';
  const opts = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: TZ };
  if (withTime) Object.assign(opts, { hour: 'numeric', minute: '2-digit' });
  return new Date(d).toLocaleString('en-IN', opts);
}

/* "in 3 days" / "in 5 hours" / "passed" */
export function timeLeft(d) {
  if (!d) return '';
  const ms = new Date(d).getTime() - Date.now();
  if (ms <= 0) return 'passed';
  const h = Math.round(ms / 3600000);
  if (h < 48) return `in ${h} hour${h === 1 ? '' : 's'}`;
  const days = Math.round(h / 24);
  return `in ${days} days`;
}

export const DEFAULT_DEADLINE_DAYS = 7;

/* How an answer reached us, in words. */
export const VIA_WORDS = {
  candidate_link: 'by the candidate, on their offer link',
  hr_on_behalf: 'on the candidate\'s behalf',
  automatic: 'automatically — no answer by the deadline',
};
